<template>
  <div class="player-view-profile">
    <div class="app-page-spinner"  v-if="loading" v-loading="loading"></div>
    <!-- Header -->
    <!-- Picture -->
    <div 
      v-if="record"
      class="player-view-profile__header"
    >
      <div 
        :style="{ backgroundImage: getPicture(record) }" 
        class="player-view-profile__header__picture" 
      />

      <!-- First Name -->
      <span class="player-view-profile__header__firstName">
        {{ presenter(record, 'firstName') }}
        {{ presenter(record, 'lastName') }}
      </span>
    </div>

    <!-- Cards -->
    <el-row>
      <!-- Card Player -->
      <el-col :lg="12" :md="12" :sm="24">
        <app-view-card
          v-if="playerCardParams"
          :titleI18n="playerCardParams.titleI18n"
          :fieldsValuesArray="playerCardParams.fieldsValuesArray"
          :icon="playerCardParams.icon"
        ></app-view-card>
      </el-col>

      <!-- Card Address -->
      <!-- TODO: direcciones de los padres -->
      <!-- <el-col :lg="12" :md="12" :sm="24">
        <app-view-card
          v-if="addressCardParams"
          :titleI18n="addressCardParams.titleI18n"
          :fieldsValuesArray="addressCardParams.fieldsValuesArray"
          :icon="addressCardParams.icon"
        />
      </el-col> -->
    </el-row>

    <!-- Team Title -->
    <h2 
        v-if="record && record.teams"
        class="app-content-subtitle"
    >
      <app-i18n code="entities.team.label.many" />
    </h2>

    <!-- Team List-->
    <el-row>
      <el-col :lg="24" :md="24" :sm="24">

       <app-player-view-profile-teams
        v-if="record && record.teams"
        :teams="record.teams"
       />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { PlayerModel } from '@modules/player/player-model';
import { AddressModel } from '@shared/model/address-model';
import { TeamModel } from '@modules/team/team-model';
import PlayerViewProfileTeams from '@modules/player/components/player-view-profile-teams.vue';

export default {
  name: 'app-player-view-profile',

  props: {
    id: {
      type: String,
      required: true
    },
    subpropertyId: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'player/view/record',
      loading: 'player/view/loading',
      isPropertyNBA: 'auth/manage/isPropertyNBA',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
    }),
    fields() {
      const { dateFormat, timeFormat} = this;
      return new PlayerModel({ dateFormat, timeFormat }).fields();
    },
    playerCardParams() {
      if (!this.record) return 
      return {
        icon: 'icon-player',
        titleI18n: 'entities.player.view.cards.profile',
        fieldsValuesArray: [
          {
            fieldI18n: 'entities.player.fields.gender',
            value: this.presenter(this.record, 'gender'),
            col: { lg: 24, md: 24, sm: 24 },
          },
          {
            fieldI18n: 'entities.player.fields.birthdate',
            value: this.presenter(this.record, 'birthdate'),
            col: { lg: 24, md: 24, sm: 24 },
          },
          {
            fieldI18n: 'entities.player.fields.isMember',
            value: this.presenter(this.record, 'isMember'),
            col: { lg: 24, md: 24, sm: 24 },
            disabled: this.isPropertyNBA,
          },
          {
            fieldI18n: 'entities.player.fields.careerInfo',
            value: this.presenter(
              this.record,
              'careerInfo',
            ),
            disabled: this.record.isMember || this.isPropertyNBA,
            col: { lg: 24, md: 24, sm: 24 },
          },
        ],
      };
    },
    addressCardParams() {
      if (this.record) {
        const { address } = this.record;

        return {
          icon: 'icon-location',
          titleI18n:
            'entities.inscription.view.card.residentialAddress',
          fieldsValuesArray: [
            {
              fieldI18n: 'entities.address.fields.line1',
              value: this.presenterAddress(
                address,
                'line1',
              ),
              col: { lg: 24, md: 24, sm: 24 },
            },
            {
              fieldI18n: 'entities.address.fields.line2',
              value: this.presenterAddress(
                address,
                'line2',
              ),
              col: { lg: 24, md: 24, sm: 24 },
            },
            {
              fieldI18n: 'entities.address.fields.state',
              value: this.presenterAddress(
                address,
                'state',
              ),
              col: { lg: 12, md: 24, sm: 24 },
            },
            {
              fieldI18n: 'entities.address.fields.city',
              value: this.presenterAddress(address, 'city'),
              col: { lg: 12, md: 24, sm: 24 },
            },
            {
              fieldI18n: 'entities.address.fields.country',
              value: this.presenterAddress(
                address,
                'country',
              ),
              col: { lg: 12, md: 12, sm: 24 },
            },
            {
              fieldI18n:
                'entities.address.fields.postalCode',
              value: this.presenterAddress(
                address,
                'postalCode',
              ),
              col: { lg: 12, md: 24, sm: 24 },
            },
          ],
        };
      }
      return null;
    },
    teamPrograms() {
      return (programsObject) => {
        if (!programsObject) return [];
        return Object.keys(programsObject).map((id) => ({
          id,
          label: programsObject[id].label,
        }));
      };
    },
    teamSubprograms() {
      return (programsObject) => {
        const subprograms = [];

        if (programsObject) {
          Object.values(programsObject).forEach(
            (programObject) => {
              if (!('subprograms' in programObject)) return;
              if (!programObject.subprograms) return;
              Object.keys(
                programObject.subprograms,
              ).forEach((subprogramId) => {
                subprograms.push({
                  id: subprogramId,
                  label:
                    programObject.subprograms[subprogramId]
                      .label,
                });
              });
            },
          );
        }

        return subprograms;
      };
    },
  },

  async created() {
    await this.doFind({id: this.id, subpropertyId: this.subpropertyId});
  },

  methods: {
    ...mapActions({
      doFind: 'player/view/doFind',
    }),

    presenter(record, fieldName) {
      if (!record) return;
      const { dateFormat, timeFormat } = this;
      return new PlayerModel({ dateFormat, timeFormat }).presenter(record, fieldName);
    },

    presenterAddress(record, fieldName) {
      if (!record) return;
      return AddressModel.presenter(record, fieldName);
    },

    presenterTeam(record, fieldName) {
      if (!record) return;
      return TeamModel.presenter(record, fieldName);
    },

    getPicture(record) {
      if(!record) return
      if (!('picture' in record)) return null;
      if (!(record.picture instanceof Array)) return null;
      if (!record.picture.length > 0) return null;
      if (!record.picture[0].publicUrl) return null;
      return `url("${record.picture[0].publicUrl}")`;
    },
  },

  components: {
    [PlayerViewProfileTeams.name]: PlayerViewProfileTeams
  }
};
</script>

<style lang="scss">
.player-view-profile {
  padding: 32px 56px;

  &__header {
    margin-bottom: 13px;

    &__picture {
      display: inline-block;
      vertical-align: middle;
      width: 81px;
      height: 81px;
      border-radius: 100%;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.1);
      background-color: #f1f0f0;
      box-sizing: border-box;
    }

    &__firstName {
      font-size: 20px;
      color: #404040;
      font-weight: bold;
      margin-left: 20px;
    }
    &__lastName {
      font-size: 14px;
      color: #404040;
    }
  }
  .app-content-subtitle {
    margin: 32px 0px 0px 0px !important;
  }
}
</style>